// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"2042f458","546":"4267164f"}[chunkId] + ".css";
};